"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Database = void 0;
var md5_1 = __importDefault(require("md5"));
var strict_event_emitter_1 = require("strict-event-emitter");
var glossary_1 = require("../glossary");
var callOrder = 0;
var Database = /** @class */ (function () {
    function Database(dictionary) {
        this.events = new strict_event_emitter_1.StrictEventEmitter();
        this.models = Object.keys(dictionary).reduce(function (acc, modelName) {
            acc[modelName] = new Map();
            return acc;
        }, {});
        callOrder++;
        this.id = this.generateId();
    }
    /**
     * Generates a unique MD5 hash based on the database
     * module location and invocation order. Used to reproducibly
     * identify a database instance among sibling instances.
     */
    Database.prototype.generateId = function () {
        var stack = new Error().stack;
        var callFrame = stack === null || stack === void 0 ? void 0 : stack.split('\n')[4];
        var salt = callOrder + "-" + (callFrame === null || callFrame === void 0 ? void 0 : callFrame.trim());
        return md5_1["default"](salt);
    };
    Database.prototype.getModel = function (name) {
        return this.models[name];
    };
    Database.prototype.create = function (modelName, entity, customPrimaryKey) {
        var primaryKey = customPrimaryKey ||
            entity[entity[glossary_1.InternalEntityProperty.primaryKey]];
        this.events.emit('create', this.id, modelName, entity, customPrimaryKey);
        return this.getModel(modelName).set(primaryKey, entity);
    };
    Database.prototype.update = function (modelName, prevEntity, nextEntity) {
        var prevPrimaryKey = prevEntity[prevEntity[glossary_1.InternalEntityProperty.primaryKey]];
        var nextPrimaryKey = nextEntity[prevEntity[glossary_1.InternalEntityProperty.primaryKey]];
        if (nextPrimaryKey !== prevPrimaryKey) {
            this["delete"](modelName, prevPrimaryKey);
        }
        this.create(modelName, nextEntity, nextPrimaryKey);
        this.events.emit('update', this.id, modelName, prevEntity, nextEntity);
    };
    Database.prototype.has = function (modelName, primaryKey) {
        return this.getModel(modelName).has(primaryKey);
    };
    Database.prototype.count = function (modelName) {
        return this.getModel(modelName).size;
    };
    Database.prototype["delete"] = function (modelName, primaryKey) {
        this.getModel(modelName)["delete"](primaryKey);
        this.events.emit('delete', this.id, modelName, primaryKey);
    };
    Database.prototype.listEntities = function (modelName) {
        return Array.from(this.getModel(modelName).values());
    };
    return Database;
}());
exports.Database = Database;
